import React from 'react';

import { CartActions, ECartActions, ISetProductVoucherCodeAction } from '../model';

export const setCopiedProductVoucherCode = (
  dispatch: React.Dispatch<CartActions>,
  data: ISetProductVoucherCodeAction,
) => dispatch({ actionType: ECartActions.SET_COPIED_PRODUCT_VOUCHER_CODE, payload: data });
